import { render, staticRenderFns } from "./ownerCars.vue?vue&type=template&id=54a07066&scoped=true"
import script from "./ownerCars.vue?vue&type=script&lang=js"
export * from "./ownerCars.vue?vue&type=script&lang=js"
import style0 from "./ownerCars.vue?vue&type=style&index=0&id=54a07066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a07066",
  null
  
)

export default component.exports